const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/backups',
    welcomeEntryPath: '/welcome',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    locale: 'en',
    enableMock: false,
}

export default appConfig
